import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../../styles/nav-bar.css";

const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("");
  const [scope, setScope] = useState("Global");
  const api_url = process.env.REACT_APP_API_URL;

  const handleRegister = async (e) => {
    e.preventDefault();
    const adminToken = localStorage.getItem("token");

    try {
      await axios.post(
        `${api_url}/api/auth/register`,
        {
          username,
          password,
          role,
          scope,
        },
        {
          headers: adminToken ? { Authorization: `Bearer ${adminToken}` } : {},
        },
      );

      Swal.fire({
        title: "User created successfully!",
        text: "The new user account has been created.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        // Stay on this page and clear the form so the current admin is not logged out
        setUsername("");
        setPassword("");
        setRole("");
        setScope("Global");
      });
    } catch (error) {
      Swal.fire({
        title: "Registration Failed!",
        text:
          error.response?.data?.error ||
          "Something went wrong. Please try again.",
        icon: "error",
        confirmButtonText: "Try Again",
      });
    }
  };

  return (
    <div className="sp-page-wrap">
      <div className="sp-panel">
        <div className="sp-panel-header">
          <i className="bi bi-person-plus-fill sp-header-icon"></i>
          <div>
            <h5 className="sp-panel-title">Add New User</h5>
            <p className="sp-panel-subtitle">Create a new account below</p>
          </div>
        </div>

        <hr className="sp-divider" />

        <form onSubmit={handleRegister}>
          <div className="sp-input-group">
            <label htmlFor="regUsername">Username</label>
            <input
              id="regUsername"
              type="text"
              className="sp-input"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="sp-input-group">
            <label htmlFor="regPassword">Password</label>
            <input
              id="regPassword"
              type="password"
              className="sp-input"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="sp-input-group">
            <label htmlFor="regRole">Role</label>
            <select
              id="regRole"
              className="sp-input"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="">Select Role</option>
              <option value="Admin">Admin</option>
              <option value="User">User</option>
            </select>
          </div>
          <div className="sp-input-group">
            <label htmlFor="regScope">Portal Access</label>
            <select
              id="regScope"
              className="sp-input"
              value={scope}
              onChange={(e) => setScope(e.target.value)}
              required
            >
              <option value="Global">Global</option>
              <option value="Local">Local</option>
              <option value="Both">Both</option>
            </select>
          </div>
          <button type="submit" className="sp-btn">
            <i className="bi bi-plus-circle me-2"></i>Add New User
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
